var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { orcidApi } from "apis/eduidOrcid";
import { EduIDButton } from "components/Common/EduIDButton";
import { useAppSelector } from "eduid-hooks";
import { FormattedMessage, useIntl } from "react-intl";
import orcidIcon from "../../../img/vector_iD_icon-w.svg";
/*********************************************************************************************************************/
/*
 * Make sure an URL has a trailing slash, optionally joining it with an endpoint.
 */
export function urlJoin(base_url, endpoint) {
    if (!base_url.endsWith("/")) {
        base_url = base_url.concat("/");
    }
    if (endpoint) {
        return base_url + endpoint;
    }
    return base_url;
}
export function Orcid() {
    const orcid = useAppSelector((state) => state.account_linking.orcid);
    const intl = useIntl();
    const [removeOrcid] = orcidApi.useLazyRemoveOrcidQuery();
    const [connectOrcid] = orcidApi.useLazyConnectOrcidQuery();
    function handleOrcidDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield removeOrcid();
        });
    }
    function handleOrcidConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield connectOrcid();
            if (response.isSuccess) {
                if (response.data.payload.location) {
                    globalThis.location.assign(response.data.payload.location);
                }
            }
        });
    }
    // aria-label can't be an Element, we need to get the actual translated string here
    const removeLabel = intl.formatMessage({
        id: "common.remove",
        defaultMessage: "Remove",
        description: "Remove orcid aria label",
    });
    if (orcid === null || orcid === void 0 ? void 0 : orcid.id) {
        return (_jsx("table", { className: "table-form orcid", children: _jsxs("tbody", { children: [_jsxs("tr", { className: "display-none", children: [_jsx("th", { children: _jsx(FormattedMessage, { id: "orcid.logo", description: "orcid logo", defaultMessage: "orcid logo" }) }), _jsx("th", { children: _jsx(FormattedMessage, { id: "orcid.id", description: "orcid id", defaultMessage: "orcid id" }) }), _jsx("th", { children: _jsx(FormattedMessage, { id: "common.removeText", description: "orcid remove", defaultMessage: "remove" }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("span", { className: "orcid-logo" }) }), _jsx("td", { className: "orcid-link", children: _jsx("a", { href: orcid.id, children: orcid.id }) }), _jsx("td", { children: _jsx(EduIDButton, { buttonstyle: "close sm", id: "remove-orcid-button", onClick: handleOrcidDelete, "aria-label": removeLabel }) })] })] }) }));
    }
    else {
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: "buttons", children: _jsxs(EduIDButton, { buttonstyle: "primary icon", id: "connect-orcid-button", onClick: handleOrcidConnect, children: [_jsx("img", { className: "orcid-logo", src: orcidIcon, alt: "Orcid logo" }), _jsx(FormattedMessage, { id: "orcid.button", description: "orcid connect button", defaultMessage: "Add ORCID account" })] }) }), _jsx("p", { className: "help-text", children: _jsx(FormattedMessage, { id: "orcid.description", description: "orcid description", defaultMessage: "ORCID iD distinguishes you from other researchers and allows linking of your research outputs and activities to your identity, regardless of the organisation you are working with." }) })] }));
    }
}
